import { Injectable, NgZone } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from './loader.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private ngZone: NgZone,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { JWToken } = JSON.parse(localStorage.getItem('userData') || '{}') || {};

    let authReq = req;
    if (JWToken) {
      authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${JWToken}`)
      });
    }

    this.loaderService.show();

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.toastr.error('Session expired. Please log in again.', 'Unauthorized');
          
          // Clear local storage
          localStorage.removeItem('userData');

          // Run inside Angular zone for navigation
          this.ngZone.run(() => {
            this.router.navigate(['/']);
          });
        }
        return throwError(() => error);
      }),
      finalize(() => {
        this.ngZone.run(() => this.loaderService.hide());
      })
    );
  }
}
